import { render, staticRenderFns } from "./DetailEducation.vue?vue&type=template&id=452510a6&scoped=true&"
import script from "./DetailEducation.vue?vue&type=script&lang=js&"
export * from "./DetailEducation.vue?vue&type=script&lang=js&"
import style0 from "./DetailEducation.vue?vue&type=style&index=0&id=452510a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452510a6",
  null
  
)

export default component.exports